export default "__VITE_ASSET__D9vat16E__"